<div class="wrapper-lg">
    <app-breadcrumbs [items]="[{ url: '/ebus/session-config', text: 'ebusSessionConfig_listTitle' }]"></app-breadcrumbs>

    <header class="content-header">
        <h1 class="h-md" [translate]="'ebusSessionConfig_listTitle'"></h1>
    </header>

    <app-table [rows]="items" [columns]="columns" [sticky]="'right'">
        <ng-template #rowTemplate let-row>
            <tr>
                <td>{{row.Code}}</td>
                <td>{{row.Description}}</td>
                <td>
                    <div class="table-actions">
                        <button type="button" class="btn btn-outline btn-icon" [ngbTooltip]="'edit' | translate"
                                [routerLink]="['/ebus/session-config', row.Id] | localize">
                            <i class="fi fi-rs-pencil"></i>
                        </button>
                    </div>
                </td>
            </tr>
        </ng-template>
    </app-table>
</div>
